import { socketInviteOnboarding } from '@nxsys/services/sockets';
import { useCallback, useEffect } from 'react';
import { SocketEvent, UseSocketOptions } from './useNotificationSocket';

/**
 * NX-6291: useNotificationSocket for the `/invite-onboarding` namespace, where
 * the multiple-select Invite Onboarding job reports its result.
 */
export const useInviteOnboardingSocket = (options: UseSocketOptions): void => {
  const { eventName, onSuccess, onError } = options;

  const handleSocketEvent = useCallback(
    (eventData: SocketEvent) => {
      if (eventData?.success) {
        onSuccess?.(eventData);
      } else {
        onError?.(eventData?.error?.message || '');
      }
    },
    [onSuccess, onError],
  );

  useEffect(() => {
    socketInviteOnboarding.on(eventName, handleSocketEvent);

    return () => {
      socketInviteOnboarding.off(eventName, handleSocketEvent);
    };
  }, [eventName, handleSocketEvent]);
};

export default useInviteOnboardingSocket;
